module.exports = __webpack_public_path__ + "img/user-profile-no-company.ab9496d7.png";